import type { Joi } from '@ksyos/koi';
import { Koi } from '@ksyos/koi';
import { phoneNumberRegex } from '../../utils/phoneNumberUtil';
import { replaceKoiError } from '../replaceKoiError';

export const phoneNumberSchema = Koi.string()
    .regex(phoneNumberRegex)
    .max(255)
    .error((errors: Joi.ErrorReport[]) => replaceKoiError(errors, 'string.pattern.base', 'invalidPhoneNumber'));
export const phoneNumberNoErrorSchema = Koi.string().regex(phoneNumberRegex).max(255);

export function onePhoneNumberRequiredSchema(firstPhoneNumberKey: string, secondPhoneNumberKey: string) {
    return Koi.object({
        [firstPhoneNumberKey]: phoneNumberSchema.allow('', null).optional().default(''),
        [secondPhoneNumberKey]: Koi.when(firstPhoneNumberKey, {
            is: ['', null],
            otherwise: phoneNumberSchema.allow('', null).optional(),
            then: phoneNumberSchema.required(),
        }),
    });
}
